import tuition from "./tuition";
import finance from "./finance";

/**
 * 华博特项目接口文档
 */
export default {
  tuition,
  finance,
};
